









































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import { SwForm, SwFormRow } from '@sonicwall/unified-ui-framework/src/shared/sw-form';

const cssPrefix = 'verify-address';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    SwFormRow,
    SwForm,
  },
})
export default class VerifyAddress extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  data : any;
  @Prop({ required : true })
  showVerifyAddress : any;
  enteredAddress : any;
  standardizedAddress : any;
  message : any;
  created() {
    console.warn(this.data);
    this.enteredAddress = this.data.enteredAddress;
    this.standardizedAddress = this.data.standardizedAddress;
    this.message = this.data.message;

  }
  closeDialog() {
    this.$emit('close-modal');
  }
  confirmSubmit(input : any) {
    console.warn(input);
    this.$emit('confirm', input);
    this.$emit('close-modal');
  }
}
